module.exports = __webpack_public_path__ + "img/arrow.3a99607c.png";